import { Injectable } from '@angular/core'
import { LayoutService } from '@layout/layout.service'

@Injectable()
export class FooterService extends LayoutService{}